import React from 'react';
import Layout from '../components/Layout';
import { GraduationCap, BookOpen, Video, FileText } from 'lucide-react';

const Training = ({ user }) => {
  const trainingModules = [
    { title: 'Grundlagen Autoglas', icon: BookOpen, duration: '30 Min', status: 'Abgeschlossen' },
    { title: 'VIN-Nummer Dekodierung', icon: FileText, duration: '15 Min', status: 'In Arbeit' },
    { title: 'DAT System Einführung', icon: Video, duration: '45 Min', status: 'Neu' },
    { title: 'GDV Datenübermittlung', icon: Video, duration: '20 Min', status: 'Neu' },
  ];

  return (
    <Layout user={user}>
      <div className="p-4 md:p-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Schulung</h1>
        <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8">Schulungsmaterialien und Trainingsmodule</p>

        {/* Progress Overview */}
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border mb-6 md:mb-8" style={{borderColor: '#E1E4E8'}}>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-base md:text-lg font-semibold text-gray-900">Ihr Fortschritt</h3>
            <span className="text-xl md:text-2xl font-bold" style={{color: '#0A4D8C'}}>25%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 md:h-3">
            <div className="h-2 md:h-3 rounded-full" style={{backgroundColor: '#0A4D8C', width: '25%'}}></div>
          </div>
          <p className="text-xs md:text-sm text-gray-600 mt-2">1 von 4 Modulen abgeschlossen</p>
        </div>

        {/* Training Modules */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {trainingModules.map((module, idx) => {
            const Icon = module.icon;
            return (
              <div
                key={idx}
                className="bg-white p-4 md:p-6 rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer"
                style={{borderColor: '#E1E4E8'}}
                data-testid={`training-module-${idx}`}
              >
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{backgroundColor: '#DBEAFE'}}>
                    <Icon className="w-5 h-5 md:w-6 md:h-6" style={{color: '#0A4D8C'}} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm md:text-base">{module.title}</h4>
                    <div className="flex flex-wrap items-center gap-2 md:gap-4 text-xs md:text-sm text-gray-600">
                      <span>{module.duration}</span>
                      <span className="px-2 py-1 rounded text-xs font-medium" style={{
                        backgroundColor: module.status === 'Abgeschlossen' ? '#D1FAE5' : module.status === 'In Arbeit' ? '#FEF3C7' : '#DBEAFE',
                        color: module.status === 'Abgeschlossen' ? '#059669' : module.status === 'In Arbeit' ? '#D97706' : '#2563EB'
                      }}>
                        {module.status}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default Training;
